import './ads.scss';

const SinglePageBannerTwo = () => {
  return (
    <div className="bannerOne">
      <a
        href="https://otieu.com/4/9585393"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/banners/New_b.webp"
          alt="Aliexpress"
          width="300"
          height="250"
        />
      </a>
    </div>
  );
};

export default SinglePageBannerTwo;
